<template>
    <SimpleForm api="monitoring" title="Monitor" id="monitor" :fields="fields"/>
</template>

<script>

import SimpleForm from '../../../components/forms/SimpleForm.vue';

const formFields = [
    'freeDiskSpaceRequired',
    'freeDiskSpaceCheckDelay'
];

export default {
    data() {
        return {
            fields: formFields
        }
    },

    components: {
        SimpleForm
    }
}

</script>
